var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _vm.formState === "default"
        ? _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-form",
                { on: { submit: _vm.signIn } },
                [
                  _c("v-text-field", {
                    attrs: {
                      tabindex: "1",
                      dense: "",
                      "prepend-icon": "mdi-account",
                      outlined: "",
                      clearable: "",
                      color: _vm.componentColor,
                      name: "Username",
                      label: _vm.$t("auth.username"),
                      placeholder: " ",
                    },
                    model: {
                      value: _vm.form.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "username", $$v)
                      },
                      expression: "form.username",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      tabindex: "2",
                      dense: "",
                      "prepend-icon": "mdi-lock",
                      "append-icon": _vm.passwordType1
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.passwordType1 ? "password" : "text",
                      clearable: "",
                      outlined: "",
                      color: _vm.componentColor,
                      name: "Password",
                      label: _vm.$t("auth.password"),
                      placeholder: " ",
                    },
                    on: {
                      "click:append": () =>
                        (_vm.passwordType1 = !_vm.passwordType1),
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                  _c(
                    "v-card-actions",
                    { staticClass: "pl-0 pr-0" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "d-flex justify-center align-center white--text",
                          attrs: {
                            type: "submit",
                            tabindex: "3",
                            primary: "",
                            block: "",
                            loading: _vm.loading,
                            dark: "",
                            color: _vm.componmentButtonColor,
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("mdi-exit-to-app"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("auth.login")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.formState === "confirm"
        ? _c(
            "v-card",
            { attrs: { flat: "", color: "rgba(255, 255, 255, 0)" } },
            [
              _c(
                "v-form",
                { on: { submit: _vm.confirmSignIn } },
                [
                  _c("v-card-title", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("auth.welcome-you-are-connecting")) +
                        ". "
                    ),
                  ]),
                  _c("v-card-subtitle", [
                    _c("br"),
                    _vm._v(_vm._s(_vm.$t("auth.for-safety-reasons"))),
                    _c("br"),
                  ]),
                  _c(
                    "v-card-text",
                    { staticStyle: { padding: "0" } },
                    [
                      _c("br"),
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "", justify: "start" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  tabindex: "1",
                                  "prepend-icon": "mdi-lock",
                                  "append-icon": _vm.passwordType1
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.passwordType1 ? "password" : "text",
                                  outlined: "",
                                  clearable: "",
                                  color: _vm.componentColor,
                                  name: "New Password",
                                  label: _vm.$t("auth.new_password"),
                                  placeholder: " ",
                                },
                                on: {
                                  "click:append": () =>
                                    (_vm.passwordType1 = !_vm.passwordType1),
                                },
                                model: {
                                  value: _vm.form.newPassword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "newPassword", $$v)
                                  },
                                  expression: "form.newPassword",
                                },
                              }),
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  tabindex: "2",
                                  "prepend-icon": "mdi-lock",
                                  "append-icon": _vm.passwordType2
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.passwordType2 ? "password" : "text",
                                  outlined: "",
                                  clearable: "",
                                  color: _vm.componentColor,
                                  name: "Confirm Password",
                                  label: _vm.$t("auth.confirm-password"),
                                  placeholder: " ",
                                },
                                on: {
                                  "click:append": () =>
                                    (_vm.passwordType2 = !_vm.passwordType2),
                                },
                                model: {
                                  value: _vm.form.newPasswordMatch,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "newPasswordMatch", $$v)
                                  },
                                  expression: "form.newPasswordMatch",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "pl-0 pr-0" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "white--text d-flex justify-center align-center",
                          attrs: {
                            tabindex: "3",
                            type: "submit",
                            disabled:
                              _vm.form.newPassword != _vm.form.newPasswordMatch,
                            block: "",
                            loading: _vm.confirmLoading,
                            color: _vm.componmentButtonColor,
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("mdi-exit-to-app"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("auth.change")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            bottom: "",
            right: "",
            shaped: "",
            value: _vm.errorExists,
            color: "secondary",
          },
        },
        [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }